import "../styles/globals.scss";
import type { AppProps } from "next/app";
import Head from "next/head";
import { useEffect, useState } from "react";
import "tailwindcss/tailwind.css";
import { ThemeProvider } from "../context/ThemeContext";
import ELayout from "../layout/ELayout";

export default function App({ Component, pageProps }: AppProps) {
  const [showChild, setShowChild] = useState(false);
  // 兼容Object.hasOwn
  if (!Object.hasOwn) {
    Object.hasOwn = function (obj, prop) {
      return Object.prototype.hasOwnProperty.call(obj, prop);
    };
  }
  useEffect(() => {
    setShowChild(true);
    setViewHeight();
    // 添加事件监听器
    window.addEventListener("resize", setViewHeight);

    // 组件卸载时移除事件监听器
    return () => window.removeEventListener("resize", setViewHeight );
  }, []);
  const setViewHeight = () => {
    const body = document.querySelector("body");
    if (!body) {
      return;
    }
    if (supportsDVH()) {
      body.style.height = "100dvh";
    } else {
      const vh = window.innerHeight;
      body.style.height = vh ? `${vh}px` : "100vh";
    }
  };
  function supportsDVH() {
    return CSS.supports("height", "100dvh");
  }
  if (!showChild) {
    return null;
  }
  return (
    <ThemeProvider>
      <Head>
        <title>CodeBot Eagle</title>
        <meta
          name="description"
          content="Eagle 是一个帮助开发人员分析代码库和项目结构的 AI Agent。它能够深入阅读和理解程序代码文件，识别关键功能，并提供详细的解释和改进建议。
"
        />
        <meta
          name="viewport"
          content="width=device-width,initial-scale=1,shrink-to-fit=no,viewport-fit=cover,minimum-scale=1,maximum-scale=1,user-scalable=no"
        />
        <script
          async
          src="https://res.wx.qq.com/open/js/jweixin-1.6.0.js"
        ></script>
        {/* <link rel="icon" href="/favicon.ico" /> */}
      </Head>
       <ELayout>
          <Component {...pageProps} />
        </ELayout>
    </ThemeProvider>
  );
}
